import { Inject, Injectable } from '@angular/core';

import { Coupon, CouponPage, CouponSubType } from '@cds/betting-offer/domain-specific/coupons';
import { FixtureFormMode, ScoreboardMode, SortByCriteria } from '@cds/query-objects';
import { BaseCdsApi, BaseCdsApiFactory, CDS_API_FACTORY } from '@frontend/sports/content-distribution/feature';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CouponApi {
    private cdsApi: BaseCdsApi;

    constructor(@Inject(CDS_API_FACTORY) cdsApiServiceFactory: BaseCdsApiFactory) {
        this.cdsApi = cdsApiServiceFactory({ endpoint: '/coupons' });
    }

    getCoupons(
        sportId: number,
        couponSubType: CouponSubType = CouponSubType.Regular,
        competitionId?: number,
        virtualCompetitionId?: number,
    ): Observable<Coupon[] | undefined> {
        return this.cdsApi.get<Coupon[]>('', { sportId, couponSubType, competitionId, virtualCompetitionId });
    }

    getMultiBuilderCoupons(maxCouponCount: number): Observable<Coupon[] | undefined> {
        return this.cdsApi.get<Coupon[]>('', { couponsubtype: 'multibuilder', maxCouponCount });
    }

    getCoupon(
        sportIds: string,
        couponId: number,
        skip: number = 0,
        take: number = 10,
        sortBy: SortByCriteria = SortByCriteria.StartDate,
        statisticsModes?: string,
        form?: FixtureFormMode,
        interval?: { from?: string; to?: string },
        couponsubtype: CouponSubType = CouponSubType.Regular,
        competitionIds?: string,
        virtualCompetitionId?: string,
    ): Observable<CouponPage | undefined> {
        return this.cdsApi.get<CouponPage>('/fixtures', {
            sportIds,
            couponId,
            skip,
            take,
            sortBy,
            fixtureForm: form,
            from: interval?.from,
            to: interval?.to,
            couponSubType: couponsubtype,
            competitionIds,
            virtualCompetitionId,
            statisticsModes,
            scoreboardMode: ScoreboardMode.Slim,
        });
    }

    getMultiBuilderCoupon(
        couponId: number,
        fromDate: Date,
        toDate: Date,
        sortBy: SortByCriteria = SortByCriteria.StartDate,
        take: number = 15,
        fixtureForm?: FixtureFormMode,
        statisticsModes?: string,
    ): Observable<CouponPage | undefined> {
        return this.cdsApi.get<CouponPage>('/fixtures', {
            couponId,
            sortBy,
            From: fromDate.toJSON(),
            To: toDate.toJSON(),
            take,
            fixtureForm,
            statisticsModes,
        });
    }
}
